import { render, staticRenderFns } from "./TitleExtraction.vue?vue&type=template&id=275b52dc&scoped=true"
import script from "./TitleExtraction.vue?vue&type=script&lang=js"
export * from "./TitleExtraction.vue?vue&type=script&lang=js"
import style0 from "./TitleExtraction.vue?vue&type=style&index=0&id=275b52dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275b52dc",
  null
  
)

export default component.exports